import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=cd245fc4&scoped=true"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"
import style0 from "./BlogPost.vue?vue&type=style&index=0&id=cd245fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd245fc4",
  null
  
)

export default component.exports